<template>
  <v-layout column class="mx-0">
    <v-carousel
      height="100wh"
      show-arrows-on-hover
      :hide-delimiters="hideDelimiters"
      :cycle="cycle"
      :class="[
        $vuetify.breakpoint.mdAndUp
          ? 'all-screen-sm-and-up'
          : 'all-screen-sm-and-down',
      ]"
    >
      <v-carousel-item v-if="$vuetify.breakpoint.mdAndUp">
        <v-img
          src="https://tidingo.sfo3.cdn.digitaloceanspaces.com/uva/portada-uval.jpg"
          :height="$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'"
          class="align-center"
          gradient="to top right, rgba(0,0,0,.10), rgba(0,0,0,.10)"
        >
        </v-img>
      </v-carousel-item>
      <v-carousel-item v-if="$vuetify.breakpoint.mdAndUp">
        <v-img
          src="/inscribete/portada2.jpg"
          :height="$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'"
          class="align-center"
          gradient="to top right, rgba(0,0,0,.10), rgba(0,0,0,.10)"
        >
        </v-img>
      </v-carousel-item>
      <v-carousel-item v-if="$vuetify.breakpoint.mdAndUp">
        <v-img
          src="/inscribete/portada3.jpg"
          :height="$vuetify.breakpoint.mdAndUp ? '100vh' : '50vh'"
          class="align-center"
          gradient="to top right, rgba(0,0,0,.10), rgba(0,0,0,.10)"
        >
        </v-img>
      </v-carousel-item>
      <v-carousel-item v-if="$vuetify.breakpoint.smAndDown">
        <v-img
          src="/inscribete/portada-movil.jpg"
          height="100vh"
          class="align-center"
          gradient="to top right, rgba(0,0,0,.10), rgba(0,0,0,.10)"
        >
        </v-img>
      </v-carousel-item>
      <v-carousel-item v-if="$vuetify.breakpoint.smAndDown">
        <v-img
          src="/inscribete/portada-movil2.jpg"
          height="100vh"
          class="align-center"
          gradient="to top right, rgba(0,0,0,.10), rgba(0,0,0,.10)"
        >
        </v-img>
      </v-carousel-item>
      <v-carousel-item v-if="$vuetify.breakpoint.smAndDown">
        <v-img
          src="/inscribete/portada-movil3.jpg"
          height="100vh"
          class="align-center"
          gradient="to top right, rgba(0,0,0,.10), rgba(0,0,0,.10)"
        >
        </v-img>
      </v-carousel-item>
      <ContactInscribete
        data-aos="fade-in"
        id="contact"
        :isMovil="$vuetify.breakpoint.mdAndUp ? false : true"
        :class="$vuetify.breakpoint.mdAndDown ? '' : 'mt-5 floating'"
      />
    </v-carousel>
    <!--<full-height-banner
      v-else
      imgSource="images/imagenes/portada.jpg"
      :isQuote="false"
      title="Licenciaturas en Línea"
      subtitle="Conviertete en el profesionista que deseas donde quiera que estés"
      subheading="Esta es la educación se adapta a tu estilo y forma de vida que necesitas para prepararte y lograr tus metas."
    />-->
    <Information />
    <!--<video-bg :sources="['UVAENLINEAPRESENTACION.mp4']"></video-bg>
    <v-carousel cycle height="100vh" show-arrows-on-hover interval="10000">
      <v-carousel-item>
        <CardCarrousel
          :imgSource="$vuetify.breakpoint.mdAndUp ? 'images/imagenes/testimonio1.jpg': 'images/imagenes/testimonio1_Movil.png'"
          :isQuote="true"
          quote="Es una gran oportunidad de seguirme preparando por mi trabajo y mi familia no puedo ir a una universidad presencial y está es una excelente opción, puedo estudiar sin descuidar mi familia y el trabajo. Estoy muy contenta de pertenecer a la Universidad Vizcaya y en un futuro poder obtener mi Título."
          person="Imelda León."
        />
      </v-carousel-item>
      <v-carousel-item>
        <CardCarrousel
          :imgSource="$vuetify.breakpoint.mdAndUp ? 'images/imagenes/testimonio2.jpg': 'images/imagenes/testimonio2_Movil.png'"
          :isQuote="true" 
          quote="Mi experiencia en Vizcaya en Línea hasta el día de hoy ha sido excelente, sobre todo por la atención brindada por parte de los asesores profesionales que forman parte de esta Institución."
          person="Yesenia."
        />
      </v-carousel-item>
      <v-carousel-item>
        <CardCarrousel
          :imgSource="$vuetify.breakpoint.mdAndUp ? 'images/imagenes/reseña.jpg': 'images/imagenes/reseña_Movil.png'"
          :isQuote="true"
          quote="Estudiar en UVA en Línea me permite completar los estudios que necesito para mi trabajo."
          person="Roberto Monreal, 40 años."
        />
      </v-carousel-item>
    </v-carousel>
    -->

    <university-carreer />
    <!-- <div class="uva">
      <v-layout
        column
        align-center
        justify-center
        fill-height
        class="white--text"
        style="position: relative; height: 80vh"
      >
        <div
          style="
            background-image: url(/imagenes/covid/2.jpeg);
            background-size: cover;
            height: 100%;
            width: 100%;
            position: absolute;
            background-position: center;
            z-index: 1;
          "
        ></div>
        <div
          style="
            position: absolute;
            z-index: 2;
            height: 100%;
            width: 100%;
            background-color: rgba(0, 0, 0, 0.3);
          "
        ></div>
        <h1
          class="white--text text-uppercase font-weight-bold mb-5 text-center"
          style="z-index: 3"
          :class="[
            $vuetify.breakpoint.mdAndUp
              ? 'display-1 '
              : 'display-1 text-center',
          ]"
        >
          Coronavirus
        </h1>

        <div
          class="justify-center align-center d-flex"
          :class="[$vuetify.breakpoint.mdAndUp ? 'flex-row' : 'flex-column']"
          style="z-index: 3"
        >
          <router-link style="text-decoration: none" :to="link_covid">
            <v-btn
              class="mt-5 mx-3 text-uppercase"
              dark
              outlined
              rounded
              color="white"
              x-large
              >Conoce más información</v-btn
            >
          </router-link>
        </div>
      </v-layout>
    </div> -->
    <!--<FrequentlyAsk />-->
    <Banner
      imgSource="images/imagenes/ventaja-quebuscas.jpg"
      imgHeight="70vh"
      title="Somos la ventaja que buscas"
      subtitle="25 años y más de 35 campus en todo el país nos respaldan"
      activeClass="display-2"
      video
      btnColor="white"
      btnRounded
      subtitleClass="font-weight-regular"
    />
    <!-- <blog-card /> -->
  </v-layout>
</template>
<style lang="scss" scoped>
.color {
  background-color: #111f3c !important;
}
html,
body {
  overflow-x: hidden !important;
}
.wordBreak {
  word-break: keep-all !important;
}
.floating {
  z-index: 4 !important;
  cursor: pointer !important;
  position: absolute !important;
  overflow: hidden !important;
  right: 60px;
  bottom: 20px;
}
</style>
<script>
import ContactInscribete from "../components/ContactInscribete.vue";
import FullHeightBanner from "../components/FullHeightBanner.vue";
import CardCarrousel from "../components/CardCarrousel.vue";
import Information from "../components/Information.vue";
import UniversityCarreer from "../components/UniversityCarreer.vue";
import FrequentlyAsk from "../components/FrequentlyAsk.vue";
import Banner from "../components/Banner.vue";
import BlogCard from "../components/BlogCard.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    ContactInscribete,
    FullHeightBanner,
    Information,
    UniversityCarreer,
    FrequentlyAsk,
    Banner,
    BlogCard,
    CardCarrousel,
  },
  data() {
    return {
      link_covid: "/covid19",
      publicPath: process.env.BASE_URL,
      hideDelimiters: true,
      cycle: true,
      name: null,
      lastname: null,
      email: null,
      phone: null,
      state: null,
      carrer: null,
      birthday: new Date().toISOString().substr(0, 10),
      date: null,
      menu: false,
      snackbar: false,
      msg: "",
      color: "",
      loading: false,
      citites: [],
      successRecaptcha: false,
    };
  },
  computed: {
    ...mapState({
      offer: (state) => state.home.offer,
      sliders: (state) => state.home.sliders,
      sliderDesktop() {
        return this.sliders.filter((event) => {
          return event.image !== null;
        });
      },
      sliderMovil() {
        return this.sliders.filter((event) => {
          return event.movil_image !== null;
        });
      },
    }),
  },
  methods: {
    reCAPTCHAcallback() {
      this.successRecaptcha = true;
    },
    renderImage(image) {
      if (image.indexOf("https") < 0) {
        return "https://www.admin-uva.tidingo.com" + image;
      } else {
        return image;
      }
    },
    sendMessage() {
      this.loading = true;
      if (
        this.name != null &&
        this.lastname != null &&
        this.email != null &&
        this.phone != null &&
        this.carrer != null
      ) {
        this.information.name_first = this.name;
        this.information.last_name = this.lastname;
        this.information.phone = this.phone;
        this.information.email = this.email;
        this.information.carrer = this.carrer;

        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("lastname", this.lastname);
        formData.append("email", this.email);
        formData.append("phone", this.phone);
        formData.append("state", "Uva en línea-UVAL");
        formData.append("carrer", this.carrer);
        formData.append("birthday", "");
        axios({
          method: "post",
          url: "https://www.informes-uva.tidingo.com/api/create-inscription",
          data: formData,
          config: {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        }).then((response) => {
          if (response.data.status == "200") {
            this.msg = "Mensaje enviado, pronto estaremos en contacto contigo.";
            this.color = "success";
            this.snackbar = true;
            this.name = null;
            this.lastname = null;
            this.email = null;
            this.phone = null;
            this.information.campus = null;
            this.carrer = null;
            this.birthday = new Date().toISOString().substr(0, 10);
          } else {
            this.msg = "Algo salio mal. Intentelo nuevamente";
            this.color = "error";
            this.snackbar = true;
          }
          this.loading = false;
        });
      } else {
        this.loading = false;
        this.msg = "Complete todos los datos";
        this.color = "warning";
        this.snackbar = true;
      }
    },
  },
};
</script>
